// AvatarImg — renders a photo if available, otherwise the emoji fallback.
// Drop-in for any avatar container div: it fills the parent circle.
export default function AvatarImg({ profile, fallback = '🏌️' }) {
  if (profile?.avatar_url) {
    return (
      <img
        src={profile.avatar_url}
        alt=""
        style={{
          width: '100%', height: '100%',
          objectFit: 'cover', borderRadius: '50%',
          display: 'block'
        }}
      />
    )
  }
  return profile?.avatar_emoji || fallback
}
